import { InputFieldLabel } from "~/operations/messages";

export type SorteKey = "loose" | "pallet" | "bigbag";

export interface SorteConfig {
  label: string;
  labelShort: string;
  icon: string;
  hasPrefix: boolean;
  defaultAmount: number;
}

export const SORTE_CONFIG: Record<SorteKey, SorteConfig> = {
  loose: {
    label: InputFieldLabel.amountKilogram,
    labelShort: InputFieldLabel.amountKilogram,
    icon: "icon-amount-pellets-default.svg",
    hasPrefix: false,
    defaultAmount: 6000,
  },
  pallet: {
    label: InputFieldLabel.amountPalet,
    labelShort: "Paletten",
    icon: "icon-amount-pellets-palet.svg",
    hasPrefix: true,
    defaultAmount: 1,
  },
  bigbag: {
    label: InputFieldLabel.amountBigbag,
    labelShort: "Big Bags",
    icon: "icon-amount-pellets-bigbag.svg",
    hasPrefix: true,
    defaultAmount: 1,
  },
};

export const PELLETS_AMOUNT_LIMITS = {
  loose: { max: 24000, min: 1000, unit: "kg" },
  packed: { max: 24, min: 1, unit: "" },
};

export function getSorteConfig(key: string | undefined | null): SorteConfig {
  if (key === "loose" || key === "pallet" || key === "bigbag") {
    return SORTE_CONFIG[key];
  }
  return SORTE_CONFIG.loose;
}

export function calculatePelletsAmount(amount: number, type: string): number {
  return type === "pallet" || type === "bigbag" ? amount * 1000 : amount;
}
